<template>
    <div class="html-block">
      <h3 class="html-block__title">{{ title }}</h3>
      <div class="html-block__content" :class="{ 'html-block__content--unstyled': listUnstyled }" v-html="content"></div>
    </div>
  </template>

  <script>
  export default {
    name: 'InfoHtml',
    props: {
      title: String,
      content: String,
      listUnstyled: {
        type: Boolean,
        default: false
      },
    }
  };
  </script>

<style scoped>
.html-block__title {
  font-size: 24px;
  margin-bottom: 1em;
}

.html-block__content {
  font-size: 20px;
}

.html-block__content {
  font-size: 20px;
}

.html-block__content--unstyled li {
  list-style: none;
}

@media (max-width: 767px) {
  .html-block__content--unstyled::v-deep img {
    width: 180px !important;
    max-width: 55vw !important;
    height: auto !important;
  }
}
</style>
